var _effectorFileName = "/builds/gmini/front-ui-kit/src/ExplorerLayout/ExplorerLayout.tsx";
import React from 'react';
import { Toolbar, Divider } from '@mui/material';
import { BottomLogo } from './BottomLogo';
import { ExplorerContainer, BodyContainer, ExplorerBody, ExplorerLayoutHeader, HeaderLeftSideWrapper, Footer, BottomBrandWrap, BottomBrandName, FooterText, Separator } from './ExplorerLayout.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ExplorerLayout = /*#__PURE__*/React.memo(({
  body,
  panelsCount,
  panelWidth,
  containerStyles,
  headerRightSide,
  navBar,
  switchProjectSelect
}) => /*#__PURE__*/_jsx(ExplorerContainer, {
  style: containerStyles,
  children: /*#__PURE__*/_jsxs(BodyContainer, {
    panelWidth: panelWidth,
    count: panelsCount,
    children: [/*#__PURE__*/_jsxs(ExplorerBody, {
      children: [/*#__PURE__*/_jsx(Toolbar, {
        disableGutters: true,
        children: /*#__PURE__*/_jsxs(ExplorerLayoutHeader, {
          children: [/*#__PURE__*/_jsxs(HeaderLeftSideWrapper, {
            children: [navBar, switchProjectSelect && navBar && /*#__PURE__*/_jsx(Separator, {}), switchProjectSelect]
          }), headerRightSide]
        })
      }), /*#__PURE__*/_jsx(Divider, {
        variant: "middle",
        style: {
          margin: '0 24px'
        }
      }), body]
    }), /*#__PURE__*/_jsxs(Footer, {
      children: [/*#__PURE__*/_jsxs(BottomBrandWrap, {
        children: [/*#__PURE__*/_jsx(BottomLogo, {}), /*#__PURE__*/_jsx(BottomBrandName, {
          children: "-TEC"
        })]
      }), /*#__PURE__*/_jsxs(FooterText, {
        children: ["Global Technology Evolving for Construction", /*#__PURE__*/_jsx("br", {}), "https://g-tec.ru"]
      })]
    })]
  })
}));
ExplorerLayout.displayName = 'ExplorerLayout';